module.exports = __webpack_public_path__ + "static/media/House_Beer_client_page2.fbde532b.png";